import React from "react";

const NotAvailable = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="not-available-icon"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8Z"
      fill="#D00000"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.17158 3.75732L3.75736 5.17154L6.58579 7.99996L3.75736 10.8284L5.17158 12.2426L8 9.41418L10.8284 12.2426L12.2426 10.8284L9.41422 7.99996L12.2426 5.17154L10.8284 3.75732L8 6.58575L5.17158 3.75732Z"
      fill="white"
    />
  </svg>
);

export default NotAvailable;
